// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Py2d","colMin":"styles_colMin__3-1NW"};